import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import reportActions from '../../report/reportActions';

import { DataTable, Page, PageContent, PageHeader, Table } from '../../components/common';
import { Button, IconButton } from '../../components/buttons';
import { IconArrowRight } from '../../components/icons';
import Utils, { SecurityRoles } from '../../common/utils';
import { ensureUserHasRoleAdminSite } from '../../auth/authComponents';

interface Props {
	actions: any;
	history: any;
	failedPayments: PaymentHistory[];
}
class FailedPaymentsListPage extends React.Component<Props, any> {
	componentDidMount() {
		this.props.actions.fetchFailedPayments();
	}

	download = () => {
		const formattedPayments = this.formatData(this.props.failedPayments);
		Utils.downloadCsv(formattedPayments, 'FailedPayments.csv');
	}
	formatData = (failedPayments: PaymentHistory[]) => {
		const formattedPayments = failedPayments.map(p => {
			return {
				Date: Utils.formatDate(p.date),
				['Invoice #']: p.stripeInvoiceNumber,
				Amount: Utils.formatCurrency(p.amount)
			};
		});

		return formattedPayments;
	}

	render() {
		const { ...props } = this.props;
		return (
			<Page title="Failed payments">
				<PageContent sectionClassName="section-lg">
					<PageHeader title="Failed Payments" />
					<div className="content-set">
						{props.failedPayments.length > 0 &&
							<div className="table-options">
								<div className="btn-group table-filters">
									<div className="table-filter">
										<Button
											className="btn-outline-primary"
											onClick={this.download}
										>
											<span className="align-middle mx-2">Download</span>
										</Button>
									</div>
								</div>
							</div>
						}
						<DataTable
							TableComponent={p => <Table isDataTable={true}>{p.children}</Table>}
							columns={[
								{
									accessor: 'id',
									show: false
								},
								{
									Header: 'Date',
									accessor: 'date',
									Cell: (row: any) => Utils.formatDate(row.value)
								},
								{
									Header: 'Invoice #',
									accessor: 'stripeInvoiceNumber'
								},
								{
									Header: 'Amount',
									accessor: 'amount',
									Cell: (row: any) => `${Utils.formatCurrency(row.value)}`
								},
								{
									Header: 'Actions',
									className: 'p-0 td-actions',
									Cell: (row: any) => (
										<IconButton
											title="View payment"
											className="btn-icon-secondary btn-icon-td"
											onClick={(e: any) => {
												e.stopPropagation(); // Prevent onClick conflict with tr onclick
												props.history.push(`/admin/reports/failed-payments/${row.original.stripeInvoiceNumber}`);
											}}
										>
											<IconArrowRight />
										</IconButton>
									)
								}
							]}
							getTrProps={(state: any, rowInfo: any, column: any) => {
								return {
									className: 'tr interactive',
									onClick: () => props.history.push(`/admin/reports/failed-payments/${rowInfo.row.stripeInvoiceNumber}`)
								};
							}}
							data={props.failedPayments}
							noDataText="No failed payments"
						/>
					</div>
				</PageContent>
			</Page>
		);
	}
}
function mapStateToProps(state: any) {
	return {
		failedPayments: state.report.failedPayments
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...reportActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connectedPage = connect(mapStateToProps, mapDispatchToProps)(FailedPaymentsListPage);
const roles = [SecurityRoles.Administrator, SecurityRoles.Agent];
export default ensureUserHasRoleAdminSite(connectedPage as any, roles);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/reports/FailedPaymentsListPage.tsx